import { render, staticRenderFns } from "./DepartmentStatus.vue?vue&type=template&id=8398c88c&"
import script from "./DepartmentStatus.vue?vue&type=script&lang=js&"
export * from "./DepartmentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports